<template>
  <div id="p-footer">
    <div class="footer-container">
      <Modalloginpartner v-if="showModalloginpartner" @close="setUser"></Modalloginpartner>
      <Subscribe v-if="showModalSubscribe" @closeSubscribe="closeSubscribe" @close="showModalSubscribe = false"></Subscribe>
      <div class="footer-rect" data-aos="fade-up" data-aos-duration="900">
        <ul class="footer-list">
          <li class="list-item-footer">
            <a :href="'/qui-est-hortense'" target="_blank">{{ $t("Hortense.whois") }}</a>
          </li>
          <li class="list-item-footer ">
            <a href="https://www.blog.hortense.green/" target="_blank">{{ $t("newspaper") }}</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/le-club-hortense'" target="_blank">{{ $t("Hortense.loyalty") }}</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/programme-de-parrainage'" target="_blank">Parrainage</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/carte-cadeau'" target="_blank">{{ $t("Hortense.gift_cards") }}</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/faq-hortense/'" target="_blank">{{ $t("Hortense.faq") }}</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/location-maison-vacances'" target="_blank">{{ $t("Hortense.made_trip") }}</a>
          </li>
          <li class="list-item-footer">
            <a href="/seminaire-eco-responsable" target="_blank">{{ $t("Hortense.business") }}</a>
          </li>
          <!-- <li class="list-item-footer">
            <a :href="'/hortense-for-wedding'" target="_blank">{{ $t("Hortense.for_wedding") }}</a>
          </li> -->
          <li class="list-item-footer">
            <a :href="'/pages/ethic/'" target="_blank">{{ $t("Hortense.ethic") }}</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/weekends'" target="_blank">Nos week-ends</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/dmc-luxe-france'" target="_blank">Travel advisors</a>
          </li>
          <li class="list-item-footer">
            <a :href="'/evenements-prives'" target="_blank">Événements privés</a>
          </li>
          <li class="list-item-footer">
<!--            <a :href="'/offres-exclusives'">{{ $t("Hortense.exclusive") }}</a>-->
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-12 col-footer d-flex justify-content-around">
          <div class="d-flex flex-column align-items-center">
            <h3 class="grid-title">{{ $t("contact") }}</h3>
            <img @click="openWhatsApp" src="../../images/WHATSAPP_img_crop.png" style="display: block; margin: 0; padding: 0; height: 3vh; object-fit: contain; vertical-align: middle;" v-set-alt class="whatsapp-icon mt-2 mb-2" />
          </div>
          <div class="d-flex flex-column align-items-center">
            <h3> {{ $t("message") }} </h3>
            <a :href="'/pages/contact/'" class="pt-1" target="_blank"> {{ $t("write") }} </a>
          </div>
          
        </div>
        <!-- <div class="col-6 col-footer">
          <h3 class="grid-title mb-5">{{ $t("join") }}</h3>
        </div> -->
      </div>



      <div class="newsletter-container" data-aos="fade-up" data-aos-duration="900">
        <div class="">
          <div class="d-flex flex-column justify-content-center newsletter-text-section">
            <h3 class="raleway-medi-p15 text-center text-uppercase">La newsletter d’hortense</h3>
            <p class="raleway-reg-p12 pr-0">En m’abonnant, j’accepte qu’Hortense m’envoie des informations et des offres par e-mail. Je peux me désabonner à tout moment. J’ai lu la Politique de confidentialité Hortense.</p>
          </div>
          <div class="subscribe-box pb-4">
            <input v-model="newsletterEmail" type="email" placeholder="Votre adresse mail" />
          </div>
          <div class="w-100">
            <button type="submit" class="hortense-btn-primary w-100" @click="subscribeNewsletter()">JE M’ABONNE</button>
          </div>
        </div>
      </div>


      <div class="col-12 col-footer">
        <h3 class="grid-title mt-4 text-center">{{ $t("join") }}</h3>
        <ul class="grid-list mt-3" data-aos="fade-up" data-aos-duration="900">
         <li class="grid-list-item pinterest">
            <a target="_blank" href="https://www.pinterest.fr/Hortense_green/">
            <i class="fa-brands fa-pinterest-p fa-xl"></i>
            </a>
          </li>
          <li class="grid-list-item linkedin">
            <a target="_blank" href="https://www.linkedin.com/company/hortense-green/">
              <i class="fa-brands fa-linkedin-in fa-xl"></i>
            </a>
          </li>
          <li class="grid-list-item instagram">
            <a target="_blank" href="https://www.instagram.com/hortense.green_/">
              <i class="fa-brands fa-instagram fa-xl"></i>
            </a>
          </li>
          <li class="grid-list-item facebook">
            <a target="_blank" href="https://www.facebook.com/maketravelgreen/">
              <i class="fa-brands fa-facebook-f fa-xl"></i>
            </a>
          </li>
          <li class="grid-list-item youtube">
            <a target="_blank" href="https://www.youtube.com/channel/UCRbKxuYZQowvCngbGeCVvMg">
              <i class="fa-brands fa-youtube fa-xl"></i>
            </a>
          </li>
        </ul>
      </div>

      <div class="mt-4 px-4">
        <button @click="openHostUrl" class="hortense-btn-primary w-100">{{ $t("host") }}</button>
      </div>

      <div class="link-footer">
        <ul class="list-link">
          <li class="link-item link-pages">
            <a :href="'/conditions-generales-utilisation/'" target="_blank">CGU</a>
          </li>
          <li class="link-item link-pages">
            <a :href="'/conditions-generales-ventes/'" target="_blank">CGV</a>
          </li>
          <li class="link-item link-pages">
            <a :href="'/mentions-legales/'" target="_blank">{{ $t("legals") }}</a>
          </li>
          <li class="link-item link-pages">
            <a :href="'/politique-confidentialité/'" target="_blank">{{ $t("policy") }}</a>
          </li>
          <li class="link-item link-pages">
            <a href="">{{ $t("payment") }}</a>
          </li>
        </ul>
        <ul class="list-picto" >
          <li class="link-item">
            <img style="height: 31px; width: 70px; object-fit: cover;" src="../../images/pay1-color.svg" v-set-alt>
          </li>
          <li class="link-item">
            <img style="height: 35px; width: 45px; object-fit: cover;"  src="../../images/pay2-color.svg" v-set-alt>
          </li>
          <li class="link-item">
            <img style="height: 31px; width: 45px; object-fit: cover;" src="../../images/pay3-color.svg" v-set-alt>
          </li>
          <!-- <li class="link-item">
            <img style="height: 42px; width: 60px; object-fit: cover;" src="../../images/pay5-color.svg" v-set-alt>
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import Modalloginpartner from 'components/modals/Modalloginpartner.vue';
  import Subscribe from 'components/modals/Subscribe.vue';
  import Flash from 'alert/Flash.vue';
  import fetcher from 'packs/shared/api.js';
  import AOS from 'aos';
  import { openWhatsAppWithPageLink } from '../../utils/whatsapp';

  export default {
    name: "p-footer",
    components: { Modalloginpartner, Subscribe, Flash },
    data() {
      return {
        showModalloginpartner: false,
        showModalBecome: false,
        showModalSubscribe: false,
        isActiveHortense: false,
        isActiveCurrencies: false,
        selectedCurrency: "FR/EUR",
        currencies: [{"currency": "FR/EUR", "lang": "fr"}, {"currency": "UK/GBP", "lang": "en"}, {'currency': "US/USD", "lang": "en"}],
        locale: 'fr',
        origin: window.location.origin,
        text: '',
        status: '',
        userInfo: {
          email: '',
          password: '',
        },
        newsletterEmail: ''
      }
    },
    mounted() {
      AOS.init();
    },
    watch: {
      locale(val) {
        this._i18n.locale = val
      }
    },
    methods: {
      async UserBasicInfo() {
        try {
          const response = await fetcher.post('/users/sign_in', {
                                                            user: {
                                                              email: this.userInfo.email,
                                                              password: this.userInfo.password,
                                                            }
                                                          })
          this.$emit('close', response.data);
          location.reload();
        } catch(e) {
          console.log(e);
        }
      },
      openHostUrl(){
        Turbolinks.visit('/devenir-hote')
      },
      setUser(user){
        if (user) {
          this.user = user;
          this.showModalloginpartner = false;
          this.$emit('close', user);
        } else {
          this.showModalloginpartner = false;
        }
      },
      closeSubscribe() {
        this.showModalSubscribe = false;
      },
      showHortense() {
        this.isActiveHortense = !this.isActiveHortense;
      },
      showCurrencies(e) {
        const el = e.currentTarget.lastElementChild;
        el.style.transform = el.style.transform ? '' : 'rotateZ(180deg)';
        this.isActiveCurrencies = !this.isActiveCurrencies;
      },
      currenciesLeft() {
        return this.currencies.filter(x => {return x.currency !== this.selectedCurrency })
      },
      selectCurrency(e) {
        this._i18n.locale = e.currentTarget.value;
        this.selectedCurrency = e.currentTarget.innerText;
        this.isActiveCurrencies = false;
        const el = document.querySelector('.arrow');
        el.style.transform = el.style.transform ? '' : 'rotateZ(180deg)';
      },
      toggleStatus(value="success") {
        this.status = this.status === value ? null : value
      },
      openWhatsApp() {
        openWhatsAppWithPageLink();
      },
      async subscribeNewsletter(){
        try {
          if (this.newsletterEmail.trim() !== '') {
            const res = await fetcher.post('/newsletters/', { newsletter: { email: this.newsletterEmail, just_mail: true }, just_mail: true })
            window.location.href = '/';
          }
        } catch (e) {
          window.location.href = '/';
          console.error(e);
        }
      },
    }
  }
</script>

<style lang="scss" scope='app/assets/stylesheets/components/p-footer'>




</style>
